import _ from 'lodash';
import { createContext, useContext, useEffect, useMemo, useReducer } from 'react';
import { appUsersAuthHandlers, appUsersAuthReducer, appUsersAuthReducerInitialState } from "../reducers/AppUsersAuthReducer";
import { AppParentContext } from './AppParentContext';
import { AppSettingsContext } from './AppSettingsContext';
import { AppUsersContext } from './AppUsersContext';
import { DatabaseContext } from './DatabaseContext';
import { EventInfoContext } from './EventInfoContext';
import { PapsContext } from './PapsContext';
import { CurrentSettingsContext } from './SettingsDataContext';
import { useAppUserAccess } from './useHelpers/useAppUserAccess';
import { useAppUserAuth } from './useHelpers/useAppUserAuth';

export const AppUsersAuthContext = createContext();

const AppUsersAuthProvider = (props) => {

  // appUserContext 
  const appUserAccess = useAppUserAccess()

  // appParentContext
  const appParentContext = useContext(AppParentContext)
  const { fn_cls } = appParentContext ?? {}

  // databaseContext
  const databaseContext = useContext(DatabaseContext)
  const { database_fns } = databaseContext ?? {}

  // appUsersContext
  const appUsersContext = useContext(AppUsersContext);
  const { appUsers_state } = appUsersContext ?? {}
  const { eventAppUsers } = appUsers_state ?? {}

  // eventInfoContext
  const eventInfoContext = useContext(EventInfoContext);
  const { eventInfo_state, eventInfo_handlers } = eventInfoContext ?? {}
  const { appProfileData } = eventInfo_state ?? {}

  // papsContext
  const papsContext = useContext(PapsContext);
  const { paps_state } = papsContext ?? {}
  const { pathViews } = paps_state ?? {}

  // appSettingsContext
  const appSettingsContext = useContext(AppSettingsContext)
  const { appSettings_state } = appSettingsContext ?? {}
  const { authOn } = appSettings_state ?? {}

  // databaseContext
  const currentSettingsContext = useContext(CurrentSettingsContext)
  const { currentSettings_state } = currentSettingsContext ?? {}

  const appUserCollection = _.get(currentSettings_state, 'gvviSettings.aps_appUserSettings.appUserCollection', {});

  // AuthReducer
  const initState = appUsersAuthReducerInitialState({ fn_cls, database_fns, pathViews, appUserCollection, appUserAccess })
  const [appUsersAuth_state, appUsersAuth_dispatch] = useReducer(appUsersAuthReducer, initState);
  const { appUserAuthList } = appUsersAuth_state ?? {}

  const { getAppUserAuths } = useAppUserAuth()

  const appUsersAuth_handlers = useMemo(
    () => appUsersAuthHandlers(appUsersAuth_dispatch),
    [appUsersAuth_dispatch]
  );

  useEffect(() => {
    if (authOn && appUserAccess && appUserAccess.isAdminOrSuper) {
      const cb = (res) => {
        appUsersAuth_handlers.handleAmmend_appUserAuthList(res)
      }
      if (!appProfileData) {
        eventInfo_handlers.handleClear_appProfileData()
      } else {
        if (!appUserAuthList) {
          if (appProfileData.eventProfiles) {
            getAppUserAuths(cb, appProfileData.eventProfiles)
          }
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [authOn, appProfileData])

  const provider = () => <AppUsersAuthContext.Provider value={{ appUsersAuth_handlers, appUsersAuth_state, }} >
    {props.children}
  </AppUsersAuthContext.Provider >

  return appUsersAuth_state ? provider() : <div></div>
}

export default AppUsersAuthProvider
